import { AxiosError, AxiosInstance } from "axios";
import { ErrorDto } from "@/api-connector/play-digital-api/models/shared-models";

const errorInterceptor = (error: AxiosError<ErrorDto>) => {
    const errorModel = error.response.data;

    errorModel.responseCode = error.code;
    errorModel.responseStatus = error.response.status;

    return Promise.reject(errorModel);
};

/** Add to the end */
export const addErrorInterceptor = (httpClient: AxiosInstance) => {
    httpClient.interceptors.response.use(null, errorInterceptor);
};
